import React from 'react';
import { formatReputationDate, getLinkTypeMeta } from '../subparts/reputationQuery';

function ReputationLinkTab({ reputationLinks }) {
    const hasLinks = reputationLinks.length > 0;

    return (
        <div className="h-100 d-flex flex-column min-h-0">
            <div className="reputation-toolbar">
                <div>
                    <h2 className="reputation-toolbar__title">Reputation Links</h2>
                    <p className="reputation-toolbar__subtitle mb-0">
                        Social and review platforms connected to your page
                    </p>
                </div>
                <span className="reputation-toolbar__summary">
                    {reputationLinks.length} link{reputationLinks.length === 1 ? '' : 's'}
                </span>
            </div>

            <div className="reputation-tab-content">
                {hasLinks ? (
                    <div className="table-responsive reputation-table-wrap">
                        <table className="table table-hover align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Platform</th>
                                    <th>Link</th>
                                    <th>Status</th>
                                    <th>Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reputationLinks.map((link) => {
                                    const linkMeta = getLinkTypeMeta(link.linkType);

                                    return (
                                        <tr key={link.id}>
                                            <td>
                                                <span className="reputation-link-platform">
                                                    <i className={`bi ${linkMeta.icon}`} aria-hidden="true"></i>
                                                    {link.linkType}
                                                </span>
                                            </td>
                                            <td>
                                                <a
                                                    href={link.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="reputation-link-url"
                                                >
                                                    {link.link}
                                                </a>
                                            </td>
                                            <td>
                                                <span
                                                    className={`reputation-active-badge ${
                                                        link.isActive ? 'is-active' : 'is-inactive'
                                                    }`}
                                                >
                                                    {link.isActive ? 'Active' : 'Inactive'}
                                                </span>
                                            </td>
                                            <td className="text-muted small">
                                                {formatReputationDate(link.createdAt)}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="reputation-empty">
                        <div className="reputation-empty__icon" aria-hidden="true">
                            <i className="bi bi-link-45deg"></i>
                        </div>
                        <h3 className="h6 fw-normal text-dark mb-1">No reputation links</h3>
                        <p className="mb-0 small text-muted">
                            Links to your social media and review platforms will appear here.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ReputationLinkTab;
